export default __webpack_public_path__ + "static/media/Dashboard.3fc0e47c.svg";